import { api } from "@/lib/api";

export const getSupplementScreening = async () =>
  (await api.get("/supplement-check/screening")).data;

export const getLatestSupplementCheck = async () =>
  (await api.get("/supplement-check/latest")).data;

export const saveSupplementCheck = async (profile, answers, labs) =>
  (await api.post("/supplement-check/save", { profile, answers, labs })).data;

export const deleteSupplementChecks = async () =>
  (await api.delete("/supplement-check")).data;